module.exports = __webpack_public_path__ + "images/link-f916c820.png";